import { render, staticRenderFns } from "./QuestionInfo.vue?vue&type=template&id=0e5a957f&"
import script from "./QuestionInfo.vue?vue&type=script&lang=js&"
export * from "./QuestionInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports